import React, { useCallback, useReducer } from 'react';
import { createApkReducer } from './createApkReducer';
import { CreateApkContext, createApkInitialState, TTypeOfCreateApkModalWindow } from './createApkContext';
import { CreateApkActionTypes } from 'modules/FirmwareAndApp/Apk/CreateApk/createApkState/createApkActions';
import { IFileData, ICreateApk, TApkType, TParametersOfApkType } from 'types';

const CreateApkState = ({ children }: JSX.ElementChildrenAttribute) => {
	const [state, dispatch] = useReducer(createApkReducer, createApkInitialState);

	const changeVersionName = useCallback((value: string) => {
		dispatch({
			type: CreateApkActionTypes.CHANGE_VERSION_NAME,
			payload: {
				versionName: value,
			},
		});
	}, []);

	const changeVersionCode = useCallback((value: string) => {
		dispatch({
			type: CreateApkActionTypes.CHANGE_VERSION_CODE,
			payload: {
				versionCode: value,
			},
		});
	}, []);

	const changeDescription = useCallback((value: string) => {
		dispatch({
			type: CreateApkActionTypes.CHANGE_DESCRIPTION,
			payload: {
				description: value,
			},
		});
	}, []);

	const changeApplicationId = useCallback((value: string) => {
		dispatch({
			type: CreateApkActionTypes.CHANGE_APPLICATION_ID,
			payload: {
				applicationId: value,
			},
		});
	}, []);

	const setParameterOfApkType = useCallback((value: Nullable<TParametersOfApkType>) => {
		dispatch({
			type: CreateApkActionTypes.SET_PARAMETER_OF_APK_TYPE,
			payload: {
				parameterOfApkType: value,
			},
		});
	}, []);

	const setIDApkType = useCallback((value: Nullable<TApkType>) => {
		dispatch({
			type: CreateApkActionTypes.SET_ID_APK_TYPE,
			payload: {
				IDApkType: value,
			},
		});
	}, []);

	const toggleCutoverBeforeUpdate = useCallback(() => {
		dispatch({
			type: CreateApkActionTypes.TOGGLE_CUTOVER_BEFORE_UPDATE,
		});
	}, []);

	const changeFileData = useCallback((value: IFileData) => {
		dispatch({
			type: CreateApkActionTypes.CHANGE_FILE_DATA,
			payload: {
				fileData: value,
			},
		});
	}, []);

	const setDataForSubmit = useCallback((value: ICreateApk | null) => {
		dispatch({
			type: CreateApkActionTypes.SET_DATA_FOR_SUBMIT,
			payload: {
				dataForSubmit: value,
			},
		});
	}, []);

	const changeTypeOfModalWindow = useCallback((value: TTypeOfCreateApkModalWindow) => {
		dispatch({
			type: CreateApkActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW,
			payload: {
				typeOfModalWindow: value,
			},
		});
	}, []);

	const resetFields = useCallback(() => dispatch({ type: CreateApkActionTypes.RESET_FIELDS }), []);

	return (
		<CreateApkContext.Provider
			value={{
				changeVersionName,
				changeVersionCode,
				changeDescription,
				changeApplicationId,
				setParameterOfApkType,
				setIDApkType,
				toggleCutoverBeforeUpdate,
				changeFileData,
				setDataForSubmit,
				changeTypeOfModalWindow,
				resetFields,
				versionName: state.versionName,
				versionCode: state.versionCode,
				description: state.description,
				applicationId: state.applicationId,
				parameterOfApkType: state.parameterOfApkType,
				IDSelectedApkType: state.IDSelectedApkType,
				isCutoverBeforeUpdate: state.isCutoverBeforeUpdate,
				fileData: state.fileData,
				dataForSubmit: state.dataForSubmit,
				typeOfModalWindow: state.typeOfModalWindow,
			}}>
			{children}
		</CreateApkContext.Provider>
	);
};

export default CreateApkState;
